module.exports = "/_next/static/images/gifts-ae9263c9b9c8702ca6ee2e495dda3a9f.png";